import { createSlice } from '@reduxjs/toolkit'
import { getExecutions, saveExecution, createExecution, deleteExecution } from './executionActions'

const initialState = {
  executions: [],
  loading: false,
  error: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedExecution: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const executionsSlice = createSlice({
  name: 'executions',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedExecution = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getExecutions.fulfilled, (state, { payload }) => {
        state.loading = false
        state.executions = payload
      })
      .addCase(getExecutions.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(saveExecution.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveExecution.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.executions[state.executions.findIndex((p) => p.id === payload.id)] = payload
        state.savedExecution = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveExecution.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createExecution.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createExecution.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedExecution = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createExecution.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteExecution.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteExecution.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteExecution.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
      .addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )
  },
})
export const { clear } = executionsSlice.actions
export default executionsSlice.reducer
